import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Spin, Tag, Select, Tooltip } from "antd";
import dayjs from "dayjs";
import "jspdf-autotable";
import CommonFooter from "../../../core/common/footer/commonFooter.jsx";
import Table from "../../../core/pagination/datatable.jsx";
import { ROLL_CALL_API_BASE_URL } from "../RollCall/RollCallConfig/RollCallConfig.js";

const KpiMetrics = () => {
  const today = dayjs();
  const tenDaysBefore = today.subtract(10, "day");
  console.log(tenDaysBefore);

  const [attendance, setAttendance] = useState([]);
  const [tabs, setTabs] = useState([]);
  const [loadingTabs, setLoadingTabs] = useState(true);
  const [selectedBranch, setSelectedBranch] = useState("0");
  const [activeTab, setActiveTab] = useState("all");

  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);
  const [loading, setloading] = useState(false);
  const [branches, setBranches] = useState([]);
  const [loadingBranches, setLoadingBranches] = useState(false);

  const navigate = useNavigate();
  const userData = JSON.parse(sessionStorage.getItem("userData"));
  const regId = userData?.RegId;
  console.log(regId);

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
      navigate("/signin");
    }
  }, [navigate]);

  useEffect(() => {
    if (tokenData && superIdData) {
      console.log("Token:", tokenData);
      console.log("SuperId:", superIdData);
    }
  }, [tokenData, superIdData]);

  // Fetch Branches from API
  const fetchBranches = async () => {
    if (!tokenData || !superIdData) return;

    setLoadingBranches(true);
    try {
      const response = await fetch(
        `${ROLL_CALL_API_BASE_URL}portal/branch/getbranch?superid=${superIdData}`, // Use dynamic superIdData
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${tokenData}`,
            "Content-Type": "application/json",
          },
        },
      );

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(
          `HTTP Error! Status: ${response.status} - ${errorText.substring(
            0,
            100,
          )}`,
        );
      }

      const data = await response.json();
      console.log("Branches Response:", data);

      if (data?.status && Array.isArray(data.ResultData)) {
        const formattedBranches = data.ResultData.map((branch) => ({
          value: branch.branchid?.toString() || "",
          label:
            `${branch.Name || ""} ${
              branch.code ? `(${branch.code})` : ""
            }`.trim() || "Unnamed Branch",
        }));

        const allOption = { value: "0", label: "All Branches" };
        setBranches([allOption, ...formattedBranches]);
      } else {
        setBranches([{ value: "0", label: "All Branches" }]);
      }
    } catch (error) {
      console.error("Error fetching branches:", error);
      setBranches([{ value: "all", label: "All Branches" }]); // Fallback
    } finally {
      setLoadingBranches(false);
    }
  };

  // Fetch branches when token and superId are available
  useEffect(() => {
    fetchBranches();
  }, [tokenData]);

  const fetchKPI = async (kpiGroup = 0, branchId = 0) => {
    if (!tokenData || !superIdData) return;

    setloading(true);

    try {
      const response = await fetch(
        `${ROLL_CALL_API_BASE_URL}portal/kpi/getkpimetrics?KPIGroup=${kpiGroup}&SuperId=${superIdData}&BranchId=${branchId}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${tokenData}`,
            "Content-Type": "application/json",
          },
        },
      );

      const data = await response.json();

      setAttendance(data?.ResultData || []);
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      setAttendance([]);
    } finally {
      setloading(false);
    }
  };

  const fetchKPIGroups = async () => {
    if (!tokenData || !superIdData) return;

    setLoadingTabs(true);
    try {
      const response = await fetch(
        `${ROLL_CALL_API_BASE_URL}portal/kpi/getKPIGroups?KPIGroupId=0&SuperId=${superIdData}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${tokenData}`,
            "Content-Type": "application/json",
          },
        },
      );

      if (!response.ok) {
        throw new Error(`HTTP Error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log(data, "KPI Groups Response");

      if (data?.status && Array.isArray(data.ResultData)) {
        const formattedTabs = data.ResultData.map((group) => ({
          id: group.Name
            ? group.Name.toLowerCase().replace(/\s+/g, "")
            : `tab-${group.ID}`,
          label: group.Name || "Unnamed Tab",
          icon: getIconForGroup(group.Name),
          groupId: group.ID, // Important: Use ID for fetchKPI
        }));

        setTabs(formattedTabs);

        // Set first tab as active by default
        if (formattedTabs.length > 0 && !activeTab) {
          setActiveTab("all");
        }
      } else {
        setTabs([]);
      }
    } catch (error) {
      console.error("Error fetching KPI Groups:", error);
      setTabs([]);
    } finally {
      setLoadingTabs(false);
    }
  };

  const getIconForGroup = (groupName) => {
    const name = (groupName || "").toLowerCase();
    if (name.includes("daily")) return "fa-chart-line";
    if (name.includes("weekly")) return "fa-calendar-week";
    if (name.includes("monthly")) return "fa-calendar-alt";
    return "fa-chart-bar"; // default
  };

  useEffect(() => {
    fetchKPIGroups();
  }, [tokenData]);

  useEffect(() => {
    if (!tokenData || !superIdData) return;

    let groupId = 0;

    if (activeTab === "all") {
      groupId = 0;
    } else {
      const currentTab = tabs.find((tab) => tab.id === activeTab);
      groupId = currentTab?.groupId ?? 0;
    }

    console.log("FINAL API PARAMS 👉", {
      groupId,
      branchId: selectedBranch,
      superId: superIdData,
    });

    fetchKPI(groupId, selectedBranch);
  }, [activeTab, selectedBranch, tabs]);

  const getKpiColumns = () => {
    const baseColumns = [
      {
        title: "S.No",
        key: "sno",
        render: (_, __, index) => index + 1,
        width: 70,
      },
      {
        title: "Title",
        dataIndex: "Title",
        key: "Title",
        render: (value) => {
          if (!value) return "-";

          const shortText =
            value.length > 15 ? value.substring(0, 15) + "..." : value;

          return (
            <Tooltip title={value}>
              <span>{shortText}</span>
            </Tooltip>
          );
        },
      },
      {
        title: "Branch",
        dataIndex: "BranchName",
        key: "BranchName",
        render: (value) => (value ? value : "-"),
      },
      {
        title: "From Date",
        dataIndex: "FromDate",
        key: "FromDate",
        render: (value) => (value ? value : "-"),
      },

      {
        title: "Description",
        dataIndex: "Description",
        key: "Description",
        render: (value) => {
          if (!value) return "-";

          const shortText =
            value.length > 15 ? value.substring(0, 15) + "..." : value;

          return (
            <Tooltip title={value}>
              <span>{shortText}</span>
            </Tooltip>
          );
        },
      },

      {
        title: "Target",
        dataIndex: "MaxValue",
        key: "MaxValue",
        render: (value) => (value ? value : "-"),
      },
    ];

    if (activeTab === "all") {
      baseColumns.push({
        title: "Type",
        dataIndex: "Kpitype",
        key: "Kpitype",
        render: (type) => {
          let icon = "fa-chart-bar";
          let color = "geekblue";

          if (type?.toLowerCase().includes("daily")) {
            icon = "fa-sun";
            color = "gold";
          } else if (type?.toLowerCase().includes("weekly")) {
            icon = "fa-calendar-week";
            color = "blue";
          } else if (type?.toLowerCase().includes("monthly")) {
            icon = "fa-calendar-alt";
            color = "purple";
          }

          return (
            <Tag color={color}>
              <i className={`fa-solid ${icon} me-2`}></i>
              {type || "N/A"}
            </Tag>
          );
        },
      });
    }

    return baseColumns;
  };

  const handleBranchChange = (value) => {
    setSelectedBranch(value); // ✅ only update state
  };
  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/rollcall/dashboard">
                        <i className="fas fa-home fa-lg" />
                      </Link>
                    </li>
                    <h4 className="breadcrumb-item " aria-current="page">
                      KPI Metric
                    </h4>
                  </ol>
                </nav>
                <h6>Track Your business performance metrics</h6>
              </div>
            </div>
          </div>

          <div className="card ">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div className="search-set col-lg-auto col-md-12 mb-md-1 mb-sm-1 mb-lg-0"></div>
              <div className="col-lg-auto col-md-12 mt-md-4 mt-sm-4 mt-lg-0">
                <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                  <div className="me-2">
                    <Select
                      placeholder="Select Branch"
                      style={{ width: 222, height: 38 }}
                      defaultValue="All Branches"
                      loading={loadingBranches}
                      onChange={handleBranchChange}
                      options={branches}
                      disabled={loadingBranches}
                    />
                  </div>
                  <div></div>
                </div>
              </div>
            </div>

            <div className="card-body">
              <div className="row">
                <div className="col-lg-3 col-md-4 col-12 mb-3">
                  <div className="card h-100">
                    <div className="card-header bg-light">
                      <h5 className="card-title mb-0">
                        <i className="fa-solid fa-layer-group me-2"></i>
                        KPI Frequency
                      </h5>
                    </div>

                    <div className="card-body p-3">
                      <div
                        className="nav flex-column nav-pills"
                        id="v-pills-tab"
                        role="tablist"
                      >
                        {loadingTabs ? (
                          <div className="text-center py-4">
                            <Spin size="large" />
                            <p className="mt-2">Loading tabs...</p>
                          </div>
                        ) : (
                          <>
                            {tabs?.length > 0 && (
                              <button
                                key="all"
                                className={`nav-link text-start mb-2 ${
                                  activeTab === "all" ? "active" : ""
                                }`}
                                onClick={() => setActiveTab("all")}
                                type="button"
                              >
                                <i className="fa-solid fa-list me-3"></i>
                                All
                              </button>
                            )}
                            {tabs.length > 0 ? (
                              tabs.map((tab) => (
                                <button
                                  key={tab.id}
                                  className={`nav-link text-start mb-2 ${
                                    activeTab === tab.id ? "active" : ""
                                  }`}
                                  onClick={() => setActiveTab(tab.id)}
                                  type="button"
                                >
                                  <i
                                    className={`fa-solid ${tab.icon} me-3`}
                                  ></i>
                                  {tab.label}
                                </button>
                              ))
                            ) : (
                              <p className="text-muted text-center py-4">
                                No tabs available
                              </p>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-9 col-md-8 col-12">
                  <div className="tab-content" id="v-pills-tabContent">
                    {activeTab === "all" && (
                      <div
                        className={`tab-pane fade show active table-responsive`}
                        id="v-pills-all"
                      >
                        {loading ? (
                          <div className="text-center my-5">
                            <Spin size="large" />
                            <p className="mt-3">Loading All KPI data...</p>
                          </div>
                        ) : attendance.length > 0 ? (
                          <Table
                            columns={getKpiColumns()}
                            dataSource={attendance}
                            pagination={{ pageSize: 10 }}
                            rowKey="ID"
                            scroll={{ x: true }}
                            bordered
                          />
                        ) : (
                          <div className="text-center my-5 py-5 border rounded bg-light">
                            {/* <i className="fa-solid fa-chart-bar fa-3x text-muted mb-3"></i> */}
                            <p className="">No KPI data available</p>
                          </div>
                        )}
                      </div>
                    )}

                    {tabs.map((tab) => (
                      <div
                        key={tab.id}
                        className={`tab-pane fade ${
                          activeTab === tab.id
                            ? "show active table-responsive"
                            : ""
                        }`}
                        id={`v-pills-${tab.id}`}
                      >
                        {loading ? (
                          <div className="text-center my-5">
                            <Spin size="large" />
                            <p className="mt-3">Loading {tab.label} data...</p>
                          </div>
                        ) : attendance.length > 0 ? (
                          <Table
                            columns={getKpiColumns()}
                            dataSource={attendance}
                            pagination={{ pageSize: 10 }}
                            rowKey="ID"
                            scroll={{ x: true }}
                            bordered
                          />
                        ) : (
                          <div className="text-center my-5 py-5 border rounded bg-light">
                            {/* <i className="fa-solid fa-chart-bar fa-3x text-muted mb-3"></i> */}
                            <p className="">
                              No KPI data available for{" "}
                              <strong>{tab.label}</strong>
                            </p>
                          </div>
                        )}
                      </div>
                    ))}

                    {tabs.length === 0 &&
                      activeTab !== "all" &&
                      !loadingTabs && (
                        <div className="text-center my-5">
                          <p className="text-muted">No KPI groups found.</p>
                        </div>
                      )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <CommonFooter />
      </div>
    </div>
  );
};

export default KpiMetrics;
